// IMPORTS


/**
 * Exporting "default" so that the import doesn't have to be named in other components.
 * To create named and/or multiple exports, use: export cont compName = {}
 * Remember to import any reactive features from 'vue' if you need reactivity (e.g. computed, ref, reactive, etc.)
 */
export default {
    /* Name the component for easy reference */
    name: 'BaseIcon',

    /* Any imported component for this file needs to be listed here */
    components: {
        
    },

    /* Declare any expected props here */
    props: {
        fill: {
            type: String,
            required: false,
            default: '#FFFFFF'
        },
        width: {
            type: [String, Number],
            required: false,
            default: 24
        },
        height: {
            type: [String, Number],
            required: false,
            default: 24
        },
        d: {
            type: String,
            required: true
        },
        clipRule: {
            type: String,
            required: false,
            default: ''
        },
        fillRule: {
            type: String,
            required: false,
            default: ''
        },
        strokeLineJoin: {
            type: String,
            required: false,
            default: ''
        },
        strokeMiterLimit: {
            type: String,
            required: false,
            default: ''
        },
    },

    /* All component logic goes here in setup(). Anything complex or verbose should be handled in an external file,
        using this as more of a "controller" for the component.
    */
    setup(props) {
        

        /* We need to return any variables/functions that we want to use in our template below. */
        return {
            props
        }
    },

    /* Define the template that will be displayed for this component (optional) */
    template: /*html*/`
        <svg xmlns="http://www.w3.org/2000/svg" 
        :width="props.width" 
        :height="props.height" 
        :viewBox="'0 0 '+props.width+' '+props.height"
        :clip-rule="props.clipRule"
        :fill-rule="props.fillRule"
        :stroke-linejoin="props.strokeLineJoin"
        :stroke-miterlimit="props.strokeMiterLimit"
        >
            <path :fill="props.fill" :d="props.d"/>
        </svg>
    `,
}